import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { map, tap, switchMap, skipWhile, filter, startWith, shareReplay, takeUntil, distinctUntilChanged, skip } from 'rxjs/operators';
import { DataService, FetchService, ScreenService, PlatformService } from '@app/data';
import { Pager } from '@app/constants';
import { DefaultIndexDoc } from '@app/graphql';

@Component({
  selector: 'app-detail',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.less']
})
export class DetailComponent implements OnDestroy {

  public strategy = this.platform.isBrowser ? 'local' : 'global';
  public currentTaxonomyPage$ = this.data.currentTaxonomyPage$;
  
  private page: any = this.data.getCurrentPage();
  private pageName = this.page.pageName;

  private _store = this.fetchService.getStore({
    storeName: this.pageName,
    id: '',
    static: false
  });
  public pager$ = this._store.pager$;
  public articles$ = this._store.articles$;
  public totalCount$ = this._store.count$;
  public status$ = this._store.status$;
  public currentDetail$: Observable<DefaultIndexDoc[] | undefined> = this._store.currentDetail$;
  public thumbnails$ = this._store.thumbnails$;
  public activeItem$ = this.screenService.activeItem$;
  public route$ = this.data.route$; 
  public showPlayBtn$ = new BehaviorSubject(false);
  private unsubscribe$: Subject<void> = new Subject();

  constructor(
  	private data: DataService,
    private fetchService: FetchService,
    private screenService: ScreenService,
    private platform: PlatformService
  ) {
    this.currentTaxonomyPage$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      //console.log('**** DetailComponent scrollInToView$ res ', res);
    });

    this.pager$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      //console.log('**** DetailComponent pager$ res ', res);
    });
  }

  ngOnDestroy(): void {
    //console.log('SearchComponent ngOnDestroy');

    this.unsubscribe$.next();
    this.unsubscribe$.complete();    
  }

  public processArticle = (article: DefaultIndexDoc): DefaultIndexDoc => {
    //console.log('DetailComponent processArticle article ', article);

    if (article.field_video_id && article.field_video_platform) {
      this.showPlayBtn$.next(true);
    }

    return article;
  };

  public getClass = (): string => this.data.getClass();

}
